import React, { useCallback, useEffect } from "react";

const usePageVisibility = (): boolean => {
    const [isVisible, setIsVisible] = React.useState("hidden");

    const setVisibilityState = useCallback(() => {
        if (typeof document === "undefined") {
            setIsVisible("hidden");
        }
        return setIsVisible(document?.visibilityState ?? "hidden");
    }, []);

    useEffect(() => {
        if (typeof document !== "undefined") {
            setIsVisible(document.visibilityState);
            document.addEventListener("visibilitychange", setVisibilityState);
        }

        return () => {
            if (typeof document !== "undefined") {
                document.removeEventListener("visibilitychange", setVisibilityState);
            }
        };
    }, [setVisibilityState]);

    return isVisible === "visible";
};

export default usePageVisibility;
